import WarningIcon from '@mui/icons-material/Warning';

const SessionExpired = () => (
	<div
		style={{
			display: 'flex',
			flexDirection: 'column',
			width: '100vw',
			height: '100vh',
			justifyContent: 'center',
			alignItems: 'center'
		}}
	>
		<WarningIcon color="warning" />
		<h2>Session Expired</h2>
		<p>Please login again to continue your session</p>
	</div>
);

export default SessionExpired;
